module.exports = __webpack_public_path__ + "static/media/waves-white.634c6eb9.svg";